
import { defineComponent, PropType } from "vue";
import IconClose from "@/components/icons/IconClose";
import IconInformation from "@/components/icons/IconInformation";
import IconWarning from "../icons/IconWarning";
import IconCheckmarkOutline from "../icons/IconCheckmarkOutline";
import IconCloseOutline from "../icons/IconCloseOutline";
import { outlineable, variantable } from "@/mixins";
export default defineComponent({
  name: "w-alert",
  props: {
    modelValue: {
      type: Boolean,
      default: true,
    },
    raised: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  mixins: [variantable, outlineable],
  data() {
    return {
      variants: {
        default: ["bg-gray-300", "text-gray-800"],
        info: ["bg-blue-300", "text-blue-800"],
        success: ["bg-green-300", "bg-text-800"],

        danger: ["bg-red-300", "text-red-800"],
        warning: ["bg-yellow-300", "text-yellow-800"],
      },
      textColors: {
        default: "text-gray-100",
        info: "text-blue-900",
        danger: "text-gray-900",
        success: "text-green-900",
        warning: "text-yellow-900",
      },
    };
  },
  methods: {
    open() {
      this.$emit("update:modelValue", true);
    },
  },
  computed: {
    classes(): Array<string> {
      let classShadow: string = this.raised ? "shadow-md" : "";
      let classes: string[] = [];
      if (this.outlined) {
        classes.push(
          "border bg-transparent",
          this.borderColors[this.variant],
          this.colors[this.variant],
          this.borderColorsHover[this.variant],
          this.borderColorsHover[this.variant]
        );
      } else {
        classes.push(this.bgColors[this.variant], this.textColors[this.variant]);
      }
      return [...classes, classShadow];
    },
  },
  components: {
    IconClose,
    info: IconInformation,
    warning: IconWarning,
    success: IconCheckmarkOutline,
    danger: IconCloseOutline,
  },
});
